import React from "react";
import PropTypes from "prop-types";
import "./headerTop.scss";
import HeaderUserConnected from "./HeaderUserConnected/HeaderUserConnected";
import HeaderUserDisconnected from "./HeaderUserDisconnected/headerUserDisconnected";
import reseau_pro from "assets/LogoRP-2025-sans-baseline.png";
import logo_unif from "assets/logo_unif.webp";
import { connect } from "react-redux";

// eslint-disable-next-line no-unused-vars
const HeaderTop = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  return (
    <div className="header__bandeau">
      <div className="header__bandeau__logos">
        <img
          src={reseau_pro}
          alt="Logo Réseau Pro"
          title="Logo Réseau Pro"
          className="logo_top"
        ></img>
        {props.auth.isConnected ? (
          <img
            className="logo_top_univ"
            src={
              API_LINK +
              `${props.auth.universityConnected.imageTransparentAndColorUrl}`
            }
            alt={"Logo Université " + props.auth.universityConnected.name}
            title={"Logo Université " + props.auth.universityConnected.name}
          ></img>
        ) : (
          <img
            src={logo_unif}
            className="logo_unif"
            alt="Logo Université Numérique Ile de France"
            title="Logo Université Numérique Ile de France"
          ></img>
        )}
      </div>
      <div className="header__bandeau__title">
        {/* <center> */}
        <p>
          Bienvenue sur Réseau Pro, la plateforme professionnelle des
          universités
        </p>
        {/* </center> */}
      </div>
      {props.auth.isConnected ? (
        <HeaderUserConnected />
      ) : (
        <HeaderUserDisconnected />
      )}
    </div>
  );
};
HeaderTop.propTypes = {
  auth: PropTypes.object,
  handleAuth: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderTop);
